// https://annuities.myaccount.pacificlife.com/enroll-ui/client
import React from "react";
import Modal from "react-modal";
import "react-datepicker/dist/react-datepicker.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

const TermsAndConditions = (params) => {
    console.log(params.TermsAndConditionsOpen);
    const CustomerServicePhone = "(800) 347-7787";
    return (
        <>
            <Modal isOpen={params.TermsAndConditionsOpen}>
                <div>
                    <div style={{ borderBottom: "2px solid black" }}>
                        <Row>
                            <Col sm={6}>
                                <h2>Terms and Conditions</h2>
                            </Col>
                            <Col sm={6} style={{ textAlign: "right" }}>
                                <Button
                                    variant="primary"
                                    onClick={() =>
                                        params.CloseTermsAndConditions(false)
                                    }
                                >
                                    Close
                                </Button>
                            </Col>
                        </Row>
                    </div>
                    Please carefully read this notice before you use the My Life
                    Insurance Account Website to access information about your
                    life insurance policy . The My Life Insurance Account
                    Website is provided by Pacific Life Insurance Company
                    ("Pacific Life " or "us") and may be used for informational
                    purposes only. In order to use this Website and access your
                    policy information, or download materials from it, you must
                    agree to abide by the following Terms and Conditions.
                    <h4>Access to Policy Information</h4>
                    <p>
                        The My Life Insurance Account Website permits you to
                        access information about your life insurance policy
                        ("policy"). You agree that these Terms and Conditions
                        are in addition to the provisions governing your policy
                        with Pacific Life that remain in full force and effect.
                        You represent on an ongoing basis that you are
                        authorized to have access to any policy for which you
                        have requested a user ID or password. Policy information
                        provided on this Website is not the official record of
                        your policy activity. Your regular policy statements
                        remain the official record.
                    </p>
                    <p>
                        Policy data provided through the My Life Insurance
                        Account Website is generally updated as of the prior
                        business day's close of business (unless otherwise
                        noted) and is subject to adjustment and correction.
                    </p>
                    <p>
                        Pacific Life reserves the right to block access to the
                        My Life Insurance Account Website for any reason.
                    </p>
                    <h4>Excluded Products</h4>
                    <p>
                        Information regarding certain Pacific Life products may
                        not be currently available through the My Life Insurance
                        Account Website.
                    </p>
                    <h4>Your Pacific Life Sales Representative</h4>
                    <p>
                        In order to better serve you, we will notify your
                        Pacific Life Sales Representative of your activity on
                        the My Life Insurance Account Website.
                    </p>
                    <h4>User ID and password</h4>
                    <p>
                        In order to safeguard information about your policy, you
                        agree to protect your user ID and password and not
                        provide them to others. You agree that Pacific Life
                        shall not be responsible for damages or loss resulting
                        from any breach of security caused by your failure to
                        maintain the confidentiality of your user ID or
                        password. If you authorize third parties to access your
                        policy information, you agree to defend, indemnify and
                        hold Pacific Life harmless against any liability,
                        losses, damages or costs and expenses (including
                        attorney fees) arising out of, or resulting from, such
                        access and use.
                    </p>
                    <h4>Email</h4>
                    <p>
                        Email is provided to you only as a convenience, and to
                        enhance communications between you and your Pacific Life
                        Customer Service Representatives. Unless the specific
                        access location says otherwise, other Internet users can
                        access messages sent to or from this Website. To protect
                        your privacy, please do not use email to communicate
                        information that you want kept confidential.
                    </p>
                    <p>
                        Pacific Life shall have no liability for any loss or
                        damage that arises from unaccepted email requests,
                        orders or instructions; or for any loss or damage that
                        results from interception and/or unauthorized use by
                        third parties of any information you send via email.
                    </p>
                    <p>
                        All email messages sent by you to our Customer Service
                        Representatives (or to you from our Customer Service
                        Representatives) and all activity on the policy may be
                        monitored and/or reviewed by Pacific Life and will be
                        recorded and archived in accordance with Pacific Life 's
                        record retention policies. These records are available
                        for review by Home Office Employees,Pacific Life Sales
                        Representatives and/or regulatory examiners.
                    </p>
                    <h4>Content</h4>
                    <p>
                        Information provided on this Website is believed to be
                        reliable when posted and Pacific Life will use
                        reasonable efforts to include accurate and up-to-date
                        information. However, due to the nature of the Internet,
                        Pacific Life cannot guarantee the timeliness, accuracy,
                        completeness or authenticity of the information
                        contained in this Website, or its suitability for any
                        purpose. Pacific Life will from time to time revise the
                        information described in this Website, and reserves the
                        right to make such changes without notice.
                    </p>
                    <p>
                        The materials and information in this Website are
                        provided "as is" and are presented without express or
                        implied warranties of any kind other than those
                        warranties which are implied by and incapable of
                        exclusion, restriction or modification under the laws
                        applicable to this agreement.
                    </p>
                    <h4>User Responsibility</h4>
                    <p>
                        You agree to immediately notify us by telephone{" "}
                        {CustomerServicePhone}, if you become aware of the
                        following:
                    </p>
                    <ol>
                        <li>
                            loss, theft or unauthorized use of your password
                            and/or policy number(s); or
                        </li>
                        <li>inaccurate information about your policy.</li>
                    </ol>
                    <p>
                        If you prefer to notify us in writing, via U.S. Mail,
                        please send it to the following mailing address:
                    </p>
                    <p>
                        PACIFIC LIFE INSURANCE COMPANY
                        <br />
                        Life Insurance Operations Center
                        <br />
                        P.O. Box 2030
                        <br />
                        Omaha, NE 68103-2030
                        <br />
                        Tel: {CustomerServicePhone}
                        <br />
                    </p>
                    <h4>Business Days and Hours of Operation</h4>
                    <p>
                        You can use the My Life Insurance Account Website to
                        access information 24 hours a day, seven days a week,
                        except during any special maintenance periods or due to
                        factors beyond Pacific Life 's control. See the
                        prospectus or your policy for details. To the extent
                        possible, we will provide prior notice on our Website of
                        such interruptions and changes but do not guarantee that
                        such notice will be provided.
                    </p>
                    <p>
                        A business day, called a valuation date in your policy,
                        is any day that the New York Stock Exchange and our life
                        insurance client services offices are open. It usually
                        ends at 4:00 p.m. Eastern time. A Customer Service
                        Representative will be available to assist you between
                        6:00 a.m. to 5:00 p.m.(PT) Monday through Friday by
                        calling {CustomerServicePhone}.
                    </p>
                    <h4>No Advice</h4>
                    <p>
                        You acknowledge that neither Pacific Life nor its
                        employees or representatives provide tax, legal,
                        accounting or investment advice, nor do we give advice
                        or offer any opinion with respect to the suitability of
                        any product or investment. This Website should not be
                        used, or relied upon by you, as a substitute for your
                        independent research or consultation with your own
                        financial, legal or tax advisors. You further understand
                        that while you may be able to access information through
                        the Internet, the availability of such information does
                        not constitute a warranty of the accuracy or the
                        completeness of such information, nor a recommendation
                        to buy or sell all or any of the securities or other
                        products or services discussed therein.
                    </p>
                    <h4>Other Information</h4>
                    <p>
                        You agree to read the terms, conditions and content of
                        the Legal and Privacy Statement for the Pacific Life
                        Insurance Company Website at http://www.pacificlife.com
                        that is incorporated into this Agreement by reference.
                    </p>
                    <h4>Amendment of this Agreement</h4>
                    <p>
                        Pacific Life may amend this Agreement from time to time.
                        Your continued use of the My Life Insurance Account
                        Website is your agreement to the terms of any and all
                        such amendment(s). Therefore, you should review the
                        Terms and Conditions of this Agreement regularly. Other
                        than such amendments, this Agreement represents the
                        complete understanding between you and Pacific Life
                        regarding the use of this Website.
                    </p>
                    <p>
                        If you do not agree with these terms and conditions of
                        use, please exit this Website.
                    </p>
                </div>

                <div></div>
            </Modal>
        </>
    );
};

export default TermsAndConditions;
